<template>
    <div class="criar-location-form">
        <!-- Loading -->
        <loading />

        <form
            @submit.prevent="sendData(routine)"
            class="form-module admin-backoffice-form"
            method="post"
            action=""
            aria-describedby="Create Customer Card Plans"
            enctype="application/x-www-form-urlencoded"
            autocomplete="on"
        >
            <div class="input-row">
                <fieldset>
                    <!-- Name -->
                    <div class="input-row-item">
                        <div data-reference="name" class="item-label-input">
                            <label
                                for="name"
                                class="form-label body-1 strong-600"
                                >Nome*</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('name')"
                                @focusout="inputValidationCase('name')"
                                v-model="name"
                                class="form-control"
                                id="name"
                                placeholder="Nome"
                                maxlength="150"
                            />
                        </div>
                    </div>

                    <!-- Endereço -->
                    <div class="input-row-item">
                        <div data-reference="address" class="item-label-input">
                            <label
                                for="address"
                                class="form-label body-1 strong-600"
                                >Morada*</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('address')"
                                @focusout="inputValidationCase('address')"
                                v-model="address"
                                class="form-control"
                                id="address"
                                placeholder="Morada"
                                maxlength="350"
                            />
                        </div>
                    </div>

                    <!-- Código Postal -->
                    <div class="input-row-item">
                        <div
                            data-reference="postalcode"
                            class="item-label-input"
                        >
                            <label
                                for="postalcode"
                                class="form-label body-1 strong-600"
                                >Código Postal*</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('postalcode')"
                                @focusout="inputValidationCase('postalcode')"
                                v-model="postalcode"
                                class="form-control"
                                id="postalcode"
                                placeholder="Código Postal"
                                maxlength="12"
                            />
                        </div>
                    </div>

                    <!-- Complemento -->
                    <div class="input-row-item">
                        <div
                            data-reference="complement"
                            class="item-label-input"
                        >
                            <label
                                for="complement"
                                class="form-label body-1 strong-600"
                                >Complemento</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('complement')"
                                @focusout="inputValidationCase('complement')"
                                v-model="complement"
                                class="form-control"
                                id="complement"
                                placeholder="Complemento"
                                maxlength="150"
                            />
                        </div>
                    </div>

                    <!-- Referencia -->
                    <div class="input-row-item">
                        <div
                            data-reference="observation"
                            class="item-label-input"
                        >
                            <label
                                for="observation"
                                class="form-label body-1 strong-600"
                                >Referência</label
                            >
                            <textarea
                                class="form-control"
                                @focusin="inputValidationCase('observation')"
                                @focusout="inputValidationCase('observation')"
                                v-model="observation"
                                placeholder="Pontos de referência e/ou observações da morada"
                                id="observation"
                                maxlength="500"
                            >
                            </textarea>
                        </div>
                    </div>

                    <!-- Descrição -->
                    <div class="input-row-item">
                        <div
                            data-reference="description"
                            class="item-label-input"
                        >
                            <label
                                for="description"
                                class="form-label body-1 strong-600"
                                >Descrição</label
                            >
                            <textarea
                                class="form-control"
                                @focusin="inputValidationCase('description')"
                                @focusout="inputValidationCase('description')"
                                v-model="description"
                                placeholder="Descrição da localidade"
                                id="description"
                                maxlength="750"
                            >
                            </textarea>
                        </div>
                    </div>
                </fieldset>
            </div>

            <!-- Submit Button -->
            <div class="input-row">
                <button
                    type="submit"
                    class="btn btn-primary btnsubmit button-body"
                    :disabled="disabled"
                >
                    {{
                        routine === "PUT"
                            ? "Guardar alterações"
                            : "Criar localização"
                    }}
                </button>

                <button
                    @click="turnBack(moduledefaultindex)"
                    type="button"
                    class="btn btncancel button-body"
                >
                    Cancelar
                </button>
            </div>
        </form>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </div>
</template>
<script>
import fetchData from "./../../../fetchData.js";
import htmlElements from "./../../../htmlElements";
import inputValidation from "./../../../validationInputs.js";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import CardElement from "./../../elements/CardElement.vue";
import responseMessage from "./../../../responseMessage.js";

export default {
    name: "LocationForm",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        routine: {
            type: String,
            required: true,
        },
        moduleindex: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: Array,
            required: true,
        },
        customdata: {
            type: Array,
            required: false,
        },
        moduledefaultindex: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            name: "",
            address: "",
            postalcode: "",
            complement: null,
            observation: null,
            description: null,
            disabled: true,
            inputNotIsValid: true,
            activeclass: "d-flex",
            moduleData: [],
            responseTimeOut: 5000,
        };
    },
    created() {
        //Set Customer Card Plan
        this.moduleData = this.moduledata;
    },
    mounted() {
        //Set Values for Update Routine
        this.setValuesForUpdate(this.moduleData);

        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        turnBack(referurl) {
            defaultWebsite.turnBack(referurl);
        },
        inputValidationCase(inputid) {
            //console.log(Object.entries(this.$data));

            //Check Inputs
            switch (inputid) {
                //name
                case "name":
                    this.disabled = inputValidation.validNameCases(1, this.name)
                        ? false
                        : true;

                    break;

                //address
                case "address":
                    this.disabled = inputValidation.validNameCases(
                        4,
                        this.address
                    )
                        ? false
                        : true;

                    break;

                //postalcode
                case "postalcode":
                    this.disabled = inputValidation.validNameCases(
                        2,
                        this.postalcode
                    )
                        ? false
                        : true;

                    break;

                //complement
                case "complement":
                    if (this.complement !== "") {
                        this.disabled = inputValidation.validNameCases(
                            4,
                            this.complement
                        )
                            ? false
                            : true;
                    }

                    break;

                //observation
                case "observation":
                    if (this.observation !== "") {
                        this.disabled = inputValidation.validNameCases(
                            4,
                            this.observation
                        )
                            ? false
                            : true;
                    }

                    break;

                //description
                case "description":
                    if (this.description !== "") {
                        this.disabled = inputValidation.validNameCases(
                            4,
                            this.description
                        )
                            ? false
                            : true;
                    }

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        setValuesForUpdate(moduleData) {
            //Check Routine
            if (this.routine === "POST") {
                return;
            }

            //Set Value
            this.name = moduleData[0].name;
            this.address = moduleData[0].address;
            this.postalcode = moduleData[0].postalcode;
            this.complement = moduleData[0].complement
                ? moduleData[0].complement
                : "";
            this.observation = moduleData[0].observation
                ? moduleData[0].observation
                : "";
            this.description = moduleData[0].description
                ? moduleData[0].description
                : "";

            //Set Conditional
            this.inputNotIsValid = false;

            //Enabled Submit Button
            this.disabled = false;
        },
        sendData(method) {
            //When the input is empty
            if (
                this.name === "" ||
                this.address === "" ||
                this.postalcode === ""
            ) {
               
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Todos os campos com * são de preenchimento obrigatório",
                    this.activeclass
                );

                this.disabled = true;

                return this.disabled;
            }

            //When the name already exist
            /* if (this.customdata.includes(this.name)) {
                //Callback Message
                alert("O nome indicado já existe em nossa base de dados.");

                this.disabled = true;

                return this.disabled;
            } */

            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            let dataForm = {
                name: this.name.trim(),
                address: this.address.trim(),
                postalcode: this.postalcode.trim(),
                complement:
                    typeof this.complement === "string"
                        ? this.complement.trim()
                        : this.complement,
                observation:
                    typeof this.observation === "string"
                        ? this.observation.trim()
                        : this.observation,
                description:
                    typeof this.description === "string"
                        ? this.description.trim()
                        : this.description,
            };

            //Check Routine
            if (this.routine === "PUT") {
                dataForm.id = this.moduleData[0].id;
            }

            //Send Data
            let response = fetchData.structureTosendData(
                this.routineurl,
                dataForm,
                this.csrftolken,
                this.routine
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Check Response
                    if (Object.is(value.classname, "success")) {
                        //Redirect for Module Index
                        window.location.replace(this.moduleindex);
                    }

                    //Enabled Button
                    this.disabled = false;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedStoreList() {
            return this.storeList;
        },
        computedDisabled() {
            return this.disabled;
        },
        computedInputIsNotValid() {
            return this.inputNotIsValid;
        },
        computedStarStore() {
            return this.starstore;
        },
    },
    watch: {
        computedStoreList() {},
        computedDisabled() {},
        computedInputIsNotValid() {},
        computedStarStore() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        cardElement: CardElement,
    },
    beforeDestroy() {
        this.name = "";
        this.address = "";
        this.postalcode = "";
        this.complement = "";
        this.observation = "";
        this.user_rule = "";
    },
};
</script>
